//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// suggestion-body imports
import { IContainer, IProps } from "./SuggestionBody.d";
import { suggestionBodyFragments } from "./SuggestionBody.gql";
// body components
import { SuggestionBodyAutopilot } from "./suggestion-body-autopilot";
import { SuggestionBodyConfigColors } from "./suggestion-body-config-colors";
import { SuggestionBodyConflictingMeeting } from "./suggestion-body-conflicting-meeting";
import { SuggestionBodyExpensiveMeeting } from "./suggestion-body-expensive-meeting";
import { SuggestionBodyExpensiveOrganizer } from "./suggestion-body-expensive-organizer";
import { SuggestionBodyLowFocusTime } from "./suggestion-body-low-focus-time";
import { SuggestionBodyOutOfOffice } from "./suggestion-body-out-of-office";
import { SuggestionBodyWeekInReview } from "./suggestion-body-week-in-review";
import { SuggestionBodyWeeklyAutopilotSummary } from "./suggestion-body-weekly-autopilot-summary";
// state
import { IReduxState } from "@reducers/root.reducer";
// util
import { EPayloadType, EConfigType } from "@util/suggestion.util";

//////////////////
// COMPONENT
//////////////////
class SuggestionBodyCmpt extends React.Component<IProps, IContainer> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const { autopilotOptions, suggestionPayload, org } = this.props;

    switch (suggestionPayload.__typename) {
      case EPayloadType.Autopilot:
        return (
          <SuggestionBodyAutopilot
            suggestionPayload={suggestionPayload}
            autopilotOptions={autopilotOptions}
            org={org}
          />
        );
      case EPayloadType.Config:
        // most config types have no body for now — all handled by header & action
        if ((suggestionPayload.configurationType as string) === EConfigType.MeetingColors) {
          // FIXME: TEMP FIX FOR GQL2TS ISSUES
          return <SuggestionBodyConfigColors org={org} />;
        }
        return <span />;
      case EPayloadType.ConflictingMeeting:
        return <SuggestionBodyConflictingMeeting suggestionPayload={suggestionPayload} org={org} />;
      case EPayloadType.ExpensiveMeeting:
        return <SuggestionBodyExpensiveMeeting suggestionPayload={suggestionPayload} org={org} />;
      case EPayloadType.ExpensiveOrganizer:
        return <SuggestionBodyExpensiveOrganizer suggestionPayload={suggestionPayload} org={org} />;
      case EPayloadType.LowFocusTime:
        return <SuggestionBodyLowFocusTime suggestionPayload={suggestionPayload} org={org} />;
      case EPayloadType.OutOfOffice:
        return <SuggestionBodyOutOfOffice suggestionPayload={suggestionPayload} org={org} />;
      case EPayloadType.WeekInReview:
        return <SuggestionBodyWeekInReview suggestionPayload={suggestionPayload} />;
      case EPayloadType.WeeklyAutopilotSummary:
        return (
          <SuggestionBodyWeeklyAutopilotSummary suggestionPayload={suggestionPayload} org={org} />
        );
      case EPayloadType.Tip:
        // tip types have no body for now — all handled by header & action
        return <span />;
      case EPayloadType.MissingAttendance:
      case EPayloadType.RunningOutOfFocusTime:
      case EPayloadType.Shell:
      default:
        // the above types are not released yet
        return <span />;
    }
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SuggestionBodyRedux = connect(mapStateToProps, {})(SuggestionBodyCmpt);

//////////////////
// RELAY
//////////////////
export const SuggestionBody = createFragmentContainer<IContainer>(
  SuggestionBodyRedux,
  suggestionBodyFragments,
);
